<template>
  <b-card :title="$t('prizeWheel.usersPrizeWheel')">
    <b-row>
      <b-col class="table-size">
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-col md="2">
                <b-form-group
                    label="گردونه شانس"
                    label-for="PrizeWheelId"
                >
                  <dynamic-select
                      v-model="filterOptions.PrizeWheelId"
                      :url="$api.prizeWheel.getAll"
                      :clearable="true"
                      label="Title"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="وضعیت"
                    label-for="IsActive"
                >
                  <v-select
                      v-model="filterOptions.Active"
                      :options="enums('IsActive')"
                      dir="rtl"
                      label="text"
                      :reduce="x => x.value"
                  />
                </b-form-group>
              </b-col>
              <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  variant="warning"
                  @click="update(1)"
                  class="mb-1 mr-1"
              >
                {{ $t('common.filter') }}
              </b-button>
            </div>
          </b-row>
        </div>
        <b-table
            bordered
            hover
            striped
            :items="items"
            :fields="fields"
            class="mt-1 mb-2 position-relative"
            responsive
            :busy="loading"
            :no-local-sorting="true"
        >
          <template #cell(FullName)="data">
            <b-link :to="{ name: 'userDetail', params: { id: data.item.UserId }}">
              <b-media
                  vertical-align="center"
                  style="align-items: center;"
              >
                <span
                    class="font-weight-bold d-block text-nowrap"
                    style="color: #6e6b7b;"
                >
                  <template v-if="data.item.Name || data.item.Family">{{ data.item.Name }} {{ data.item.Family }}</template>
                  <template v-else>کاربر زیره</template>
                </span>
                <small class="text-muted">{{ data.item.UserId }}</small>
              </b-media>
            </b-link>
          </template>
          <template #cell(StartDate)="data">
            {{ data.value | date }}
          </template>
          <template #cell(EndDate)="data">
            {{ data.value | date }}
          </template>
          <template #cell(Active)="data">
            <b-badge :variant="data.value ? 'success' : 'danger'">
              {{ data.value ? $t('common.active') : $t('common.deactive') }}
            </b-badge>
          </template>

          <template #table-busy>
            <div
                class="text-center my-2"
            >
              <b-spinner
                  variant="primary"
                  class="align-middle"
              />
              <strong class="ml-1" v-text="$t('common.loading')" />
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import DynamicSelect from '@/tools/dynamicSelect.vue'
export default {
  name: 'prizeWheels',
  components: { DynamicSelect },
  data() {
    return {
      loading: false,
      filterOptions: {
        PrizeWheelId: null,
        Active: true,
        Page: 1,
        PerPage: 10,
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'FullName',
          label: this.$t('common.fullName'),
        },
        {
          key: 'Mobile',
          label: this.$t('login.mobile'),
        },
        {
          key: 'PrizeName',
          label: this.$t('prizeWheel.PrizeName'),
        },
        {
          key: 'PrizeTypeText',
          label: this.$t('prizeWheel.prizeType'),
        },
        {
          key: 'Title',
          label: this.$t('prizeWheel.prizeWheel'),
        },
        {
          key: 'StartDate',
          label: this.$t('common.startDate'),
          sortable: true,
        },
        {
          key: 'EndDate',
          label: this.$t('common.endDate'),
          sortable: true,
        },
        {
          key: 'Active',
          label: this.$t('common.status'),
        },
      ],
      items: [],
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.get(this.$api.prizeWheel.prizeWheelUsers, { params: this.filterOptions })
          .then(res => {
            this.items = res.data
          })
          .finally(() => {
            this.loading = false
          })
    }
  },
}
</script>
